<template>
  <b-modal id="studentsToPartnersModal"
           centered
  >
    <template #modal-title>
      <h5>
        <em class="fas fa-edit"></em> Редактирование статистики по целевым студентам
      </h5>
    </template>
    <template #default>
      <div class="students-to-partners-grid">
        <ag-grid-vue
          class="students-to-partners-grid-ag ag-theme-material"
          :gridOptions="gridOptions"
          :columnDefs="columnDefs"
          @grid-ready="onGridReady"
        >
        </ag-grid-vue>
      </div>
    </template>
    <template #modal-footer>
      <b-button cols="auto" @click="onSubmit"  variant="primary">
        <em class="fas fa-save"></em> Сохранить
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import { mapActions, mapGetters } from 'vuex'

import AG_GRID_LOCALE_RU from '@/config/locale.ru'
import NumericEditor from '@/components/statistic/editors/NumericEditor'

export default {
  name: 'StudentsToPartnersModal',
  components: {
    'ag-grid-vue': AgGridVue
  },
  data() {
    return {
      gridOptions: {
        defaultColDef: {
          headerClass: 'ag-grid-table-header',
          sortable: true,
          cellStyle: {
            'word-break': 'break-all'
          }
        },
        pagination: true,
        paginationPageSize: 5,
        headerHeight: 40,
        localeText: AG_GRID_LOCALE_RU,
        frameworkComponents: {
          NumericEditor
        }
      },
      columnDefs: [
        {
          headerName: 'Год',
          field: 'year',
          sort: 'desc'
        },
        {
          headerName: 'Целевые студенты',
          field: 'count',
          editable: true,
          cellEditor: 'NumericEditor'
        }
      ],
      rowData: null
    }
  },
  computed: {
    ...mapGetters({
      studentsToPartnersForYear: 'statistics/getStatsStudentsToPartners'
    })
  },

  created() {
    this.fetchStatsStudentsToPartners()
      .then(() => {
        this.loadedStudentsToPartners = true
        this.rowData = this.studentsToPartnersForYear
      })
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi
      this.gridApi.sizeColumnsToFit()
      this.gridApi.setDomLayout('autoHeight')
      this.gridOptions.api.setRowData(this.rowData)
    },
    async onSubmit() {
      await this.updateStatsStudentsToPartners(this.rowData)
        .then(() => {
          this.pushToasts({
            title: 'Уведомление',
            message: 'Редактирование целевых студентов произошло успешно'
          })
        })
        .catch((error) => {
          this.pushToasts({
            title: 'Ошибка',
            error: true,
            message: 'При редактировании целевых студентов произошла ошибка'
          })
          console.log(error)
        })
      this.$parent.repeatRender()
      this.$bvModal.hide('studentsToPartnersModal')
    },
    ...mapActions({
      fetchStatsStudentsToPartners: 'statistics/fetchStatsStudentsToPartners',
      updateStatsStudentsToPartners: 'statistics/updateStatsStudentsToPartners',
      pushToasts: 'toasts/pushToasts'
    })
  }
}
</script>


<style>
  .students-to-partners-grid .students-to-partners-grid-ag {
    width: 100%;
    height: 100%;
  }

  .students-to-partners-grid .ag-grid-table-header {
    font-size: 15px;
    display: flex;
    color: #000;
    font-weight: bold;
  }

  .students-to-partners-grid .ag-theme-material .ag-cell.ag-cell-inline-editing {
    padding: 24px;
    height: 48px !important;
    border: 0 !important;
    box-shadow: none !important;
    background: none !important;
  }

  .students-to-partners-grid {
    width: 100%;
    height: 45vh;
  }
</style>
